import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Row, Col, UncontrolledTooltip } from "reactstrap";
import InitialsAvatar from "pages/Profile/InitialsAvatar";
import profileImg from "../../assets/images/profile.png";
import { getUserColor } from "helpers/component_helpers";
import { useSelector } from "react-redux";
import CardItem from "components/PurpleTheme/CardItem";

const RcaItemList = ({ data, all_users }) => {
  const headers = [
    { name: "Name", width: 2, justify: "center" },
    { name: "Date", width: 2, justify: "center" },
    { name: "Status", width: 2, justify: "center" },
    { name: "Action Items", width: 2, justify: "center" },
    { name: "Owner", width: 1, justify: "center" },
    { name: "Reviewer", width: 2, justify: "center" },
  ];
  const { rcas } = useSelector(state => ({rcas: state.Rca.rcas}));

  const getDate = (timestamp) => {
    const timestampObj = new Date(timestamp);
    return timestampObj.toLocaleDateString("en-GB", { timeZone: "UTC" });
  };

  const [allCheckBox, setAllCheckBox] = useState(false);
  const [checkBox, setCheckBox] = useState({});

  const getCompletedActionItems = (rcaId) => {
    const associatedItems = rcas.action_items.filter((item) => item.rca_id === rcaId);
    const completedItems = associatedItems.filter((item) => item.status === "Completed");
    return {
      completed: completedItems.length,
      total: associatedItems.length,
    };
  };

  const handleCheckBox = (key) => {
    const updatedCheckBox = { ...checkBox };
    if (updatedCheckBox[key]) {
      delete updatedCheckBox[key];
    } else {
      updatedCheckBox[key] = true;
    }
    setCheckBox(updatedCheckBox);
    setAllCheckBox(false);
  };

  const handleAllCheckBox = () => {
    const updatedCheckBox = {};
    if (allCheckBox) {
      setCheckBox({});
    } else {
      data.forEach((_, index) => {
        updatedCheckBox[index] = true;
      });
      setCheckBox(updatedCheckBox);
    }
    setAllCheckBox(!allCheckBox);
  };

  return (
      <React.Fragment>
        <div>
          <div className="header px-0 mt-4">
            <div className="resources-header-card">
              <Row className="align-items-center pt-2">
                <Col md={1} lg={1}>
                  <div className="mb-2 text-center" style={{ paddingRight: "15px" }}>
                    {allCheckBox ? (
                        <i className="bx bx-check-square bx-sm" onClick={handleAllCheckBox}></i>
                    ) : (
                        <i className="bx bx-square bx-sm" onClick={handleAllCheckBox}></i>
                    )}
                  </div>
                </Col>
                {headers.map((header, index) => (
                    <Col lg={header.width} md={header.width} key={index}>
                      <div className={`d-flex align-items-center justify-content-${header.justify}`}>
                        {header.name}
                      </div>
                    </Col>
                ))}
              </Row>
            </div>
          </div>
          <div className="scrollable-container-transparent">
            {data ? (
                data.map((item, index) => {
                  const { completed, total } = getCompletedActionItems(item.rca.id);

                  return (
                      <div className="my-3 justify-content-center align-items-center" key={index}>
                        <CardItem className="px-0 py-1">
                          <Row>
                            <Col lg={1} className="d-flex align-items-center justify-content-center">
                              <div className="text-center">
                                {checkBox[index] ? (
                                    <i className="bx bx-check-square bx-sm" onClick={() => handleCheckBox(index)} />
                                ) : (
                                    <i className="bx bx-square bx-sm" onClick={() => handleCheckBox(index)} />
                                )}
                              </div>
                            </Col>
                            <Col lg={2} className="d-flex align-items-center">
                              <Link className="resource-name-truncate" to={`/rca-form/${item.rca.id}`}>
                                {item.rca.title}
                              </Link>
                            </Col>
                            <Col lg={2} className="d-flex align-items-center">{getDate(item.rca.created_at)}</Col>
                            <Col lg={2} className="d-flex align-items-center">{item.rca.status}</Col>
                            <Col lg={2} className="d-flex align-items-center">
                              {`${completed}/${total} completed`}
                            </Col>
                            <Col lg={1} className="d-flex justify-content-center align-items-center">
                              {all_users[item.rca.owner]?.profile_picture_url ? (
                                <div>
                                <img
                                    id={`TooltipTop_owner_${index}`}
                                    src={all_users[item.rca.owner]?.profile_picture_url}
                                    alt="Profile"
                                    style={{ borderRadius: "50%", width: "40px", height: "40px" }}
                                />
                                <UncontrolledTooltip placement="top" target={`TooltipTop_owner_${index}`}>
                                  {all_users[item.rca.owner]?.name}
                                </UncontrolledTooltip>
                                </div>
                              ) : (
                                <div>
                                  <InitialsAvatar
                                      name={all_users[item.rca.owner]?.name}
                                      id={`TooltipTop_owner_${index}`}
                                      userColor={getUserColor(all_users[item.rca.owner]?.email)}
                                      dimensions="40px"
                                      marginBottom='0'
                                  />
                                  <UncontrolledTooltip placement="top" target={`TooltipTop_owner_${index}`}>
                                    {all_users[item.rca.owner]?.name}
                                  </UncontrolledTooltip>
                                </div>
                              )}
                            </Col>
                            <Col lg={2} className="d-flex justify-content-center align-items-center">
                              {all_users[item.rca.reviewer]?.profile_picture_url ? (
                                <div>
                                  <img
                                      id={`TooltipTop_reviewer_${index}`}
                                      src={all_users[item.rca.reviewer]?.profile_picture_url}
                                      alt="Profile"
                                      style={{ borderRadius: "50%", width: "40px", height: "40px" }}
                                  />
                                  <UncontrolledTooltip placement="top" target={`TooltipTop_reviewer_${index}`}>
                                    {all_users[item.rca.reviewer]?.name}
                                  </UncontrolledTooltip>
                                </div>
                              ) : (
                                <div>
                                  <InitialsAvatar
                                      name={item?.rca.reviewer ? all_users[item.rca.reviewer]?.name : "No reviewer assigned"}
                                      id={`TooltipTop_reviewer_${index}`}
                                      userColor={getUserColor(all_users[item.rca.reviewer]?.email)}
                                      dimensions="40px"
                                      marginBottom='0'
                                  />
                                  <UncontrolledTooltip placement="top" target={`TooltipTop_reviewer_${index}`}>
                                    {all_users[item.rca.reviewer]?.name}
                                  </UncontrolledTooltip>
                                </div>
                              )}
                            </Col>
                          </Row>
                        </CardItem>
                      </div>
                  );
                })
            ) : (
                <div>Loading</div>
            )}
          </div>
        </div>
      </React.Fragment>
  );
};

export default RcaItemList;
